import Logo from '@/components/Logo'
import Link from 'next/link'

const DESKTOP_COLS = [
	{
		t: 'विभाग',
		items: [
			{ label: 'सर्व बातम्या', href: '/all-news' },
			{ label: 'ताज्या बातम्या', href: '/latest-news' },
			{ label: 'ट्रेंडिंग', href: '/trending' },
			{ label: 'शहरानुसार', href: '/city-wise-news' },
			{ label: 'सर्वाधिक वाचलेले', href: '/most-read' },
		],
	},
	{
		t: 'कंपनी',
		items: [
			{ label: 'आमच्याबद्दल', href: '/company/about-us' },
			{ label: 'संपर्क', href: '/company/contact-us' },
			{ label: 'संपादकीय धोरण', href: '/company/editorial-policy' },
			{ label: 'जाहिरात द्या', href: '/company/advertise' },
		],
	},
	{
		t: 'धोरणे',
		items: [
			{ label: 'गोपनीयता', href: '/company/privacy-policy' },
			{ label: 'अटी व शर्ती', href: '/company/terms-and-conditions' },
			{ label: 'कुकी धोरण', href: '/company/cookie-policy' },
		],
	},
	{
		t: 'बातम्या',
		items: [
			{ label: 'निवडक बातम्या', href: '/recommended' },
			{ label: 'अलीकडे अद्यतन', href: '/recently-updated' },
			{ label: 'एव्हरग्रीन', href: '/evergreen' },
			{ label: 'मिनी ट्रेंडिंग', href: '/mini-trending' },
		],
	},
]

export default function Footer() {
	return (
		<footer className="bg-[#0f1f2e] text-white mt-8 md:mt-10">

			{/* Desktop / tablet footer */}
			<div className="hidden md:block site-container py-10 md:py-12">
				<div className="grid grid-cols-2 lg:grid-cols-[1.5fr_repeat(4,minmax(0,1fr))] gap-8 lg:gap-10 mb-8">

					<div className="col-span-2 lg:col-span-1">
						<Logo big inverted />
						<p className="mr text-[13px] leading-relaxed opacity-70 mt-3 max-w-xs">
							मराठीतून विश्वासार्ह बातम्या · संपादकीय निष्ठा आणि वाचनीय अनुभव.
						</p>
					</div>

					{DESKTOP_COLS.map((col) => (
						<div key={col.t}>
							<div className="mr text-xs font-bold tracking-widest uppercase mb-3 opacity-85">
								{col.t}
							</div>

							<ul className="flex flex-col gap-2.5">
								{col.items.map((item) => (
									<li key={item.href}>
										<Link
											href={item.href}
											className="mr text-[13px] opacity-70 hover:opacity-100 transition-opacity"
										>
											{item.label}
										</Link>
									</li>
								))}
							</ul>
						</div>
					))}
				</div>

				<div className="border-t border-white/10 pt-5 flex flex-col sm:flex-row justify-between items-start sm:items-center text-xs opacity-60 gap-2 sm:gap-4">
					<span>© 2026 Prajavarta Media Pvt. Ltd. RNI: MAHMAR/2024/12345</span>
					<span>v1.0</span>
				</div>
			</div>

			{/* Mobile footer */}
			<div className="block md:hidden site-container py-6">
				<Logo big inverted />

				<p className="mr text-[13px] leading-relaxed opacity-70 mt-3 max-w-xs">
					मराठीतून विश्वासार्ह बातम्या · संपादकीय निष्ठा आणि वाचनीय अनुभव.
				</p>

				<div className="grid grid-cols-2 gap-6 mt-6">
					{DESKTOP_COLS.map((col) => (
						<div key={col.t}>
							<div className="mr text-[11px] font-bold tracking-widest uppercase mb-2.5 opacity-85">
								{col.t}
							</div>

							<ul className="flex flex-col gap-2">
								{col.items.map((item) => (
									<li key={item.href}>
										<Link href={item.href} className="mr text-xs opacity-70 hover:opacity-100">
											{item.label}
										</Link>
									</li>
								))}
							</ul>
						</div>
					))}
				</div>

				<div className="border-t border-white/10 pt-4 mt-6 text-[10px] opacity-50">
					© 2026 Prajavarta · RNI: MAHMAR/2024/12345
				</div>
			</div>

		</footer>
	)
}
